import { ref, onMounted, onUnmounted, type Ref } from 'vue'

export function useScrollSticky(targetRef: Ref<HTMLElement | null>) {
  const isSticky = ref(false)

  function onScroll() {
    if (!targetRef.value) return
    const rect = targetRef.value.getBoundingClientRect()

    isSticky.value = rect.bottom < 0
  }

  onMounted(() => {
    window.addEventListener('scroll', onScroll, { passive: true })

    onScroll()
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
  })

  return { isSticky }
}